import React from "react";
import Rightside from "../listing/components/right";
import Breadcrumbs from "../listing_detail/component/breadcrumbs";
import Agent_info from "./components/agent_detail";
import Photos_deatil from "./components/agent_photos";
import Agent_review from "./components/review_listing";
import Success_cases from "./components/success_cases";




function Agent_listing() {
    return (
        <div className="breacam_bg top_space">
            <div className="agent_listing">
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div className="agent_detail_wrap">
                                <Agent_info />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="agent_internal_info">
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div className="detail_area">
                                <div className="row">
                                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                                        <div className="box_detail_area">
                                            <div className="box_area">
                                                <div className="icon_area">
                                                    <i class="fas fa-map-marker-alt"></i>
                                                </div>
                                                <h5>Canada</h5>
                                                <p>Lorem 45 sitdor amet</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                                        <div className="box_detail_area">
                                            <div className="box_area">
                                                <div className="icon_area">
                                                    <i class="far fa-check-circle"></i>
                                                </div>
                                                <h5>90%</h5>
                                                <p>Sucess Rate</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                                        <div className="box_detail_area">
                                            <div className="box_area">
                                                <div className="icon_area">
                                                    <i class="far fa-user-friends"></i>
                                                </div>
                                                <h5>5000+</h5>
                                                <p>Sucess Cases</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6">
                                        <div className="box_detail_area">
                                            <div className="box_area">
                                                <div className="icon_area">
                                                    <i class="far fa-graduation-cap"></i>
                                                </div>
                                                <h5>30+</h5>
                                                <p>Universities</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="university_listing_wrap">
                <div className="container">
                    <div className="row">
                        <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                            <div className="university_wrap">
                                <div className="left_wrap">
                                    {/* <Rightside /> */}
                                    <Agent_review />
                                </div>
                                <div className="right_area">
                                    <div className="success_cases">
                                        <Success_cases />
                                        <Photos_deatil />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    );
}

export default Agent_listing;
